import React, { useState, useEffect } from "react";
import { Button, Card } from "reactstrap";
import Minicard from "../../Components/Dashboard/miniCard";
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import SwipeLeftOutlinedIcon from '@mui/icons-material/SwipeLeftOutlined';
import DashboardCardHeader from "../../Components/Dashboard/dashboardCardHeader";
import ApexPieChartProjectStages from "../../Components/Common/ApexPieChartProjectStages";
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { CircularProgress, TextField } from "@mui/material";
import SearchDropDownListPaginationComponent from "../../../src/Components/casp/common/SearchDropDownPaginationList";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import ApexBarTechnology from "../../Components/Common/ApexBarTechnology";
import Autocomplete from '@mui/material/Autocomplete';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import { toast } from "react-toastify";
import { getDashboardAllData, getGenderWisePMCount } from "../../api/casp/dashboard";
import { getUserList } from "../../api/casp/user";
import { getAllPortfolios } from "../../api/casp/portfolio";
import { Country } from "country-state-city";
import { Role } from "../../constants/Common";
import { useSelector } from "react-redux";
// import { Clear } from "@material-ui/icons";
import NoDataFound from "../../Components/Common/NoDataFound";
import Ticket from "../../assets/images/icons/ticket.png";
import { getAllProject } from "../../api/casp/project";
import { ProjectStatuses } from "../../constants/Status";
import { useNavigate, useLocation } from "react-router-dom";
import { Modules } from "../../constants/Module";
import { SectorColor } from "../../constants/PriorityIcon";
import AddProjectDrawer from "../../Components/casp/project/AddProjectDrawer";
import { withTranslation, useTranslation } from "react-i18next";
import MaleAVatar from "../../assets/images/male_avatar.png"
import FemaleAVatar from "../../assets/images/female_avatar.png"
import { Clear } from "@mui/icons-material";

const DashboardNew = (props) => {
  const { t } = useTranslation();
  const [projectDashboardData, setProjectDashboardData] = useState();
  const [selectedRole, setSelectedRole] = useState(Role.EPMO_OFFICER)
  const [update, setUpdate] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userloading, setUserLoading] = useState(false);
  const navigate = useNavigate()
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [taskStatusGraph, setTaskStatusGraph] = useState();
  const [startupType, setStartupType] = useState();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [initialDashboardData, setInitialDashboardData] = useState()
  const [projectId, setProjectId] = useState()
  const [country, setCountry] = useState()
  const [femalePM, setFemalePM] = useState(0)
  const [malePM, setMalePM] = useState(0)

  const initialFilter = {
    projectAdminId: '',
    projectOwnerId: '',
    projectSponsorId: '',
    portfolioId: '',
    country: '',
  }
  const [filterData, setFilterData] = useState(initialFilter)
  const location = useLocation()

  const [excludeFilterIds, setExcludeFilterIds] = useState([{
    name: 'projectAdminId',
    value: []
  },
  {
    name: 'projectOwnerId',
    value: []
  },
  {
    name: 'projectSponsorId',
    value: []
  }]);

  document.title = t("Dashboard");

  useEffect(() => {
    const selectedMenu = location.state?.role ? JSON.parse(location.state?.role) : '';
    if (selectedMenu) {
      setSelectedRole(selectedMenu)
    }

    setFilterData(initialFilter)
    fetchAllDashboard({ role: selectedMenu || selectedRole })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.role])

  // useEffect(() => {
  //   fetchGenderWisePMCount()
  // }, [])

  const fetchAllDashboard = async (params) => {
    try {
      setLoading(true)
      const response = (await getDashboardAllData(params))?.data?.data
      setProjectDashboardData(response)
      setInitialDashboardData(response)
      startUpTypeGroupBy(response?.totalRunningProject);
      if (response?.taskList) {
        taskStatusGroupBy(response.taskList)
      }
      response.genderWisePMCount.forEach(res => {
        if (res.gender === 'Female') { setFemalePM(res.count) }
        else if (res.gender === 'Male') { setMalePM(res.count) }
      });

      setUpdate(update + 1)
    } catch (err) {
      toast.error(err.message)
    } finally {
      setLoading(false)
    }
  }

  // const fetchGenderWisePMCount = async () => {
  //   try {
  //     setUserLoading(true)
  //     const response = (await getGenderWisePMCount())?.data?.data
  //     response.forEach(res => {
  //       if (res.gender === 'Female') { setFemalePM(res.count) }
  //       else if (res.gender === 'Male') { setMalePM(res.count) }
  //     });
  //   } catch (err) {
  //     toast.error(err.message)
  //   } finally {
  //     setUserLoading(false)
  //   }
  // }

  const copyToClipboard = async () => {
    try {
      const textField = document.createElement('textarea');
      textField.innerText = window.location.origin;//`https://kvp32.com/`
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      toast.success(t('Visitor share link generated successfully'));
      textField.remove();
    } catch (err) {
      toast.error(err.message)
    }
  };

  const reports = [
    {
      icon: AssignmentTurnedInOutlinedIcon,
      count: projectDashboardData?.totalProject ?? 0,
      onClick: () => {
        if (selectedRole) {
          const filterFields = ['projectUsers'];
          const filterInputs = [selectedRole];

          if (filterData?.projectAdminId?.id && projectId) {
            filterFields.push('id');
            filterInputs.push(projectId);
          }

          if (filterData.country.name && country) {
            filterFields.push('country');
            filterInputs.push(country);
          }

          navigate("/all-projects", {
            state: {
              filterData: JSON.stringify({
                filterFields,
                filterInputs
              })
            }
          });
        } else {
          navigate("/all-projects");
        }
      },

      text: props.t("No of Startups"),
      iconBgColor: "#DCECFF",
      iconColor: "#316BE8",
    },
    {
      icon: AssignmentTurnedInOutlinedIcon,
      count: projectDashboardData?.totalRunningProject?.length ?? 0,
      text: props.t("Running Startups"),
      onClick: () => {
        let filterFields, filterInputs
        if (selectedRole) {
          filterFields = ["status", "projectUsers"]
          filterInputs = [ProjectStatuses.ONGOING, selectedRole]
        } else {
          filterFields = ["status"]
          filterInputs = [ProjectStatuses.ONGOING]
        }
        navigate('/all-projects', {
          state: {
            filterData: JSON.stringify({ filterFields: filterFields, filterInputs: filterInputs })
          }
        })
      },
      iconBgColor: "#E5FFF1",
      iconColor: "#0ABA5B",
    },
    {
      icon: AssignmentTurnedInOutlinedIcon,
      count: projectDashboardData?.totalCompletedProject?.length ?? 0,
      text: props.t("Graduated Startups"),
      onClick: () => {
        let filterFields, filterInputs
        if (selectedRole) {
          filterFields = ["status", "projectUsers"]
          filterInputs = [ProjectStatuses.COMPLETED, selectedRole]
        } else {
          filterFields = ["status"]
          filterInputs = [ProjectStatuses.COMPLETED]
        }
        navigate('/all-projects', {
          state: {
            filterData: JSON.stringify({ filterFields: filterFields, filterInputs: filterInputs })
          }
        })
      },
      iconBgColor: "rgba(132, 243, 169, 1)",
      iconColor: "#06402B",
    },
    {
      icon: AccountBalanceWalletOutlinedIcon,
      count: projectDashboardData?.financialBalance,
      text: props.t("Total Funds"),
      iconBgColor: "#FFFAD0",
      iconColor: "#FB9D07",
    },
    {
      icon: SwipeLeftOutlinedIcon,
      count: projectDashboardData?.totalChangeRequest,
      text: props.t("Requests from Startups"),
      iconBgColor: "#E5FFC4",
      iconColor: "#6DBE07",
    },
  ];

  const [showFilter, setShowFilter] = useState(false);
  const handleFilterShow = () => {
    setShowFilter(!showFilter);
  }

  const handleFilter = async () => {
    setLoading(true)
    setProjectDashboardData()
    setTaskStatusGraph()
    const payload = {
      ...(filterData.projectAdminId?.id && {
        projectAdminId: filterData.projectAdminId?.id
      }),
      ...(filterData.projectOwnerId?.id && {
        projectOwnerId: filterData.projectOwnerId?.id
      }),
      ...(filterData.projectSponsorId?.id && {
        projectSponsorId: filterData.projectSponsorId?.id
      }),
      ...(filterData.portfolioId?.id && {
        portfolioId: filterData.portfolioId?.id
      }),
      ...(filterData.country?.name && {
        country: filterData.country?.name
      }),
      role: selectedRole
    }
    try {
      const response = (await getDashboardAllData(payload))?.data?.data
      setCountry(response?.projectFilter?.[0]?.country ?? filterData?.country?.name)
      setProjectId(response?.projectFilter[0]?.id)
      setProjectDashboardData(response)
      startUpTypeGroupBy(response.totalRunningProject)
      if (response.taskList) {
        taskStatusGroupBy(response.taskList)
      }
      response.genderWisePMCount.forEach(res => {
        if (res.gender === 'Female') { setFemalePM(res.count) }
        else if (res.gender === 'Male') { setMalePM(res.count) }

      });
    } catch (err) {
      toast.error(err.message)
    } finally {
      setLoading(false)
    }
  }

  const taskStatusGroupBy = (data) => {
    const validItems =
      data?.filter((item) => item.status && item.status.name) || [];
    const uniqueStatusArray = [...new Set(validItems.map((item) => item.status.name))];
    const countWithLabel = []
    uniqueStatusArray?.forEach((item) => {
      const filter = validItems.filter((el) => el.status.name === item);
      countWithLabel.push({
        status: item,
        _count: filter?.length,
        color: filter[0]?.status?.color
      })
    })
    setTaskStatusGraph(countWithLabel)
  }

  const startUpTypeGroupBy = (data) => {
    const validItems = data?.filter(item => item.projectType && item.projectType.name) || [];
    const uniqueStatusArray = [...new Set(validItems.map((item) => item.projectType.name))];
    const countWithLabel = []
    uniqueStatusArray?.forEach((item) => {
      const filter = validItems.filter((el) => el.projectType.name === item);
      countWithLabel.push({
        projectType: item,
        _count: filter?.length,
      })
    })
    setStartupType(countWithLabel)
  }

  const toggleDrawer = (anchor, open) => (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setIsDrawerOpen(true)
  };

  const handleCloseDrawer = async (message) => {
    setIsDrawerOpen(false);
    if (message === "success") {
      setProjectDashboardData([]);
      await fetchAllDashboard({ role: selectedRole });
    }
  };

  return (
    <div className="page-content projects dashboard_pg" key={update}>
      <div className="container-fluid">
        <div className="dashboard_header d-flex justify-content-between align-items-center">
          <div>
            <h4 className="mb-0">{props.t("Strategic Dashboard")}</h4>
          </div>
          <div className="d-flex justify-content-end ongoingSearchField">
            {loggedInUser?.role?.name === Role.EPMO_OFFICER && (
              <>
                <Button
                  className="main-login-btn btn btn-secondary d-flex align-items-center me-3"
                  onClick={toggleDrawer("right", true)}
                >
                  <i className="las la-plus d-inline-block me-2"></i>
                  {props.t("New Startup")}
                </Button>
                <Button
                  className="main-login-btn btn btn-primary d-flex align-items-center"
                  onClick={copyToClipboard}
                >
                  {props.t("Share Link")}
                </Button>
              </>
            )}
            <Button
              className="greyButton ms-3 btn btn-secondary"
              onClick={handleFilterShow}
            >
              <TuneOutlinedIcon
                className="me-1"
                style={{ width: "18px", position: "unset" }}
              />
              {showFilter ? props.t("Hide Filter") : props.t("Filter")}
            </Button>
          </div>
        </div>
        {showFilter && (
          <div className="dashboard_filter_card mb-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>{props.t("Filter")}</h5>
              <div className="d-flex">
                <Button
                  className="main-login-btn btn btn-secondary d-flex align-items-center"
                  onClick={handleFilter}
                >
                  {props.t("Apply Filter")}
                </Button>
                <Button
                  onClick={() => {
                    setProjectDashboardData();
                    setTaskStatusGraph();
                    setProjectDashboardData(initialDashboardData);
                    startUpTypeGroupBy(
                      initialDashboardData.totalRunningProject
                    );
                    if (initialDashboardData?.taskList) {
                      taskStatusGroupBy(initialDashboardData.taskList);
                    }

                    setFilterData(initialFilter);
                    setUpdate(update + 1);
                  }}
                  className="d-flex align-items-center greyButton ms-3"
                >
                  <RestartAltOutlinedIcon
                    className="me-2"
                    style={{ width: "18px" }}
                  />
                  {props.t("Reset")}
                </Button>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-sm-6 mb-3">
                <SearchDropDownListPaginationComponent
                  label={props.t("Incubator")}
                  searchEnabled={true}
                  listCall={getAllPortfolios}
                  defaultValue={
                    filterData?.portfolioId?.id ? filterData?.portfolioId : ""
                  }
                  apiParams={{
                    order: "updatedAt",
                    direction: "desc",
                    ...(![
                      Role.EPMO_MANAGER,
                      Role.ROOT_ADMIN,
                      Role.VICE_PRESIDENT,
                      Role.PRESIDENT,
                      Role.PROGRAM_MANAGER,
                      Role.EPMO_OFFICER,
                    ].includes(loggedInUser?.role?.name) && {
                      filterFields: "portfolioUser",
                      filterInputs: loggedInUser.id,
                    }),
                  }}
                  emitItem={(newValue) => {
                    setFilterData({
                      ...filterData,
                      portfolioId: newValue || "",
                    });
                  }}
                />
              </div> */}
              <div className="col-sm-6 mb-3">
                <SearchDropDownListPaginationComponent
                  label={props.t("Startup")}
                  searchEnabled={false}
                  listCall={getAllProject}
                  emitItem={(newValue) => {
                    if (newValue?.id) {
                      navigate(`/project/${newValue?.id}/details`);
                    }
                  }}
                  apiParams={{
                    filterFields: ["projectUsers"],
                    filterInputs: [selectedRole],
                    order: "updatedAt",
                    direction: "desc",
                  }}
                />
              </div>
              {selectedRole !== Role.PROJECT_MANAGER && (
                <div className="col-sm-6 mb-3">
                  <SearchDropDownListPaginationComponent
                    label={props.t("Founder")}
                    searchEnabled={true}
                    listCall={getUserList}
                    defaultValue={
                      filterData?.projectAdminId?.id
                        ? filterData?.projectAdminId
                        : ""
                    }
                    apiParams={{
                      order: "firstName",
                      direction: "desc",
                      isActive: true,
                      includeAdmins: false,
                      ...(excludeFilterIds.find(
                        (ex) => ex.name === "projectAdminId"
                      )?.value?.length !== 0 && {
                        excludeFilterFields: "id",
                        excludeFilterInputs: excludeFilterIds
                          .find((ex) => ex.name === "projectAdminId")
                          ?.value?.join(","),
                      }),
                    }}
                    emitItem={(newValue) => {
                      setExcludeFilterIds((prev) => {
                        return [
                          ...prev.map((p) => {
                            if (p.name === "projectAdminId") {
                              return { ...p };
                            } else {
                              return {
                                ...p,
                                value: [
                                  ...p.value.filter(
                                    (_v) =>
                                      _v !== filterData?.projectAdminId?.id
                                  ),
                                  ...(newValue ? [newValue.id] : []),
                                ],
                              };
                            }
                          }),
                        ];
                      });
                      setFilterData({
                        ...filterData,
                        projectAdminId: newValue ? newValue : "",
                      });
                    }}
                  />
                </div>
              )}
              {/* {selectedRole !== Role.PROJECT_OWNER && (
                <div className="col-sm-4 mb-3">
                  <SearchDropDownListPaginationComponent
                    label='Project Owner'
                    searchEnabled={true}
                    defaultValue={filterData?.projectOwnerId?.id ? filterData?.projectOwnerId : ''}
                    listCall={getUserList}
                    apiParams={{
                      order: "firstName",
                      direction: "desc",
                      isActive: true,
                      includeAdmins: false,
                      ...(excludeFilterIds.find((ex) => ex.name === 'projectOwnerId')?.value?.length !== 0 && {
                        excludeFilterFields: "id",
                        excludeFilterInputs: excludeFilterIds.find((ex) => ex.name === 'projectOwnerId')?.value?.join(',')
                      })
                    }}
                    emitItem={(newValue) => {
                      setExcludeFilterIds((prev) => {
                        return [...prev.map((p) => {
                          if (p.name === 'projectOwnerId') {
                            return { ...p }
                          } else {
                            return {
                              ...p,
                              value: [...p.value.filter((_v) => _v !== filterData?.projectOwnerId?.id), ...(newValue ? [newValue.id] : [])]
                            }
                          }
                        })]
                      })
                      setFilterData({
                        ...filterData,
                        projectOwnerId: newValue ? newValue : ''
                      })
                    }}
                  />
                </div>
              )}
              {selectedRole !== Role.PROJECT_SPONSOR && (
                <div className="col-sm-4 mb-3">
                  <SearchDropDownListPaginationComponent
                    label='Project Sponsor'
                    searchEnabled={true}
                    listCall={getUserList}
                    defaultValue={filterData?.projectSponsorId?.id ? filterData?.projectSponsorId : ''}
                    apiParams={{
                      order: "firstName",
                      direction: "desc",
                      isActive: true,
                      includeAdmins: false,
                      ...(excludeFilterIds.find((ex) => ex.name === 'projectSponsorId')?.value?.length !== 0 && {
                        excludeFilterFields: "id",
                        excludeFilterInputs: excludeFilterIds.find((ex) => ex.name === 'projectSponsorId')?.value?.join(',')
                      })
                    }}
                    emitItem={(newValue) => {
                      setExcludeFilterIds((prev) => {
                        return [...prev.map((p) => {
                          if (p.name === 'projectSponsorId') {
                            return { ...p }
                          } else {
                            return {
                              ...p,
                              value: [...p.value.filter((_v) => _v !== filterData?.projectSponsorId?.id), ...(newValue ? [newValue.id] : [])]
                            }
                          }
                        })]
                      })
                      setFilterData({
                        ...filterData,
                        projectSponsorId: newValue ? newValue : ''
                      })
                    }}
                  />
                </div>
              )} */}
              <div className="col-sm-6 mb-3">
                <Autocomplete
                  id="combo-box-demo"
                  sx={{ width: "100%" }}
                  options={Country.getAllCountries()}
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  name="country"
                  size="small"
                  defaultValue={
                    filterData?.country?.name ? filterData?.country?.name : ""
                  }
                  onChange={(e, val) => {
                    setFilterData({
                      ...filterData,
                      country: val,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={props.t("Country")} />
                  )}
                  clearIcon={filterData.country ? <Clear /> : null}
                  required
                />
              </div>
              <div className="col-sm-6 mb-3">
                <SearchDropDownListPaginationComponent
                  label={props.t("Cohort")}
                  searchEnabled={true}
                  listCall={getAllPortfolios}
                  defaultValue={
                    filterData?.portfolioId?.id ? filterData?.portfolioId : ""
                  }
                  apiParams={{
                    order: "updatedAt",
                    direction: "desc",
                    ...(![
                      Role.EPMO_MANAGER,
                      Role.ROOT_ADMIN,
                      Role.VICE_PRESIDENT,
                      Role.PRESIDENT,
                      Role.PROGRAM_MANAGER,
                      Role.EPMO_OFFICER,
                    ].includes(loggedInUser?.role?.name) && {
                      filterFields: "portfolioUser",
                      filterInputs: loggedInUser.id,
                    }),
                  }}
                  emitItem={(newValue) => {
                    setFilterData({
                      ...filterData,
                      portfolioId: newValue || "",
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {!projectDashboardData && loading && (
          <div className="text-center">
            <CircularProgress />
          </div>
        )}
        {projectDashboardData && (
          <div>
            {selectedRole === Role.MEMBER ? (
              <>
                <div className="epmo_charts_row team_member_charts">
                  <div className="seperate_section">
                    <Card className="proj_list mb-2">
                      <DashboardCardHeader
                        title={props.t("Task Status")}
                        borderBottom="false"
                        fontSize="14px"
                      />
                      <ApexPieChartProjectStages
                        data={taskStatusGraph ? taskStatusGraph : []}
                        role={selectedRole}
                      />
                    </Card>
                    {/* <Card className="proj_list mb-2">
                    <DashboardCardHeader
                      title={"Task Status"}
                      borderBottom="false"
                      fontSize="14px" />
                    <ApexPieChartProjectStatus data={[projectDashboardData?.projectOnLateCount, projectDashboardData?.projectOnTrackCount]} role={selectedRole} />
                  </Card> */}
                  </div>
                  <div className="dashboardCardStats epmo_dash_cards mb-2">
                    <div className="card proj_list mb-2">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2"
                          style={{
                            backgroundColor: "#BFF2EF",
                            color: "#18B8AF",
                          }}
                        >
                          <AssignmentTurnedInOutlinedIcon />
                        </div>
                        <div className="statWrapper">
                          <div className="statCount">
                            {projectDashboardData?.totalDocument}
                          </div>
                          <div className="statText">{props.t("Documents")}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="epmo_tables_team_member">
                  <div className="proj_list task_dash_list mb-3">
                    <h5>{props.t("Task Name")}</h5>
                    {projectDashboardData?.taskList?.length > 0 ? (
                      <ul className="list-inline mb-0">
                        {projectDashboardData?.taskList?.map((item, index) => (
                          <li
                            className="projs cursor-pointer"
                            key={index}
                            onClick={() =>
                              navigate(
                                `/project/${item?.projectId}/ticket/${item.id}`
                              )
                            }
                          >
                            {item?.name}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <NoDataFound text="No data found" icon={Ticket} />
                    )}
                  </div>
                  <div className="proj_list grey_bg mb-3 p-0">
                    <h5>{props.t("Team Mates")}</h5>
                    <ul className="recentTaskListing p-0 list-inline">
                      <li>
                        <div className="d-grid threeColumns justify-content-between align-items-center">
                          <div className="challenge_header taskBasicDetail">
                            {props.t("Name")}
                          </div>
                          <div className="challenge_header teamPersonName">
                            {props.t("Email")}
                          </div>
                          <div className="challenge_header ms-4">
                            {props.t("Contact No")}
                          </div>
                        </div>
                      </li>
                      {projectDashboardData?.teamMemberList?.length > 0 ? (
                        projectDashboardData?.teamMemberList?.map(
                          (item, index) => (
                            <li key={index}>
                              <div className="d-grid threeColumns justify-content-between align-items-center">
                                <div className="challenge_header">
                                  {item?.user?.name}
                                </div>
                                <div className="challenge_header">
                                  {item?.user?.email}
                                </div>
                                <div className="challenge_header ms-4">
                                  {item?.user?.contactNo}
                                </div>
                              </div>
                            </li>
                          )
                        )
                      ) : (
                        <NoDataFound text="No data found" icon={Ticket} />
                      )}
                    </ul>
                  </div>
                </div>
              </>
            ) : (
              <div>
                <div className="dashboard_upper_cards">
                  <Minicard reports={reports} />
                </div>
                <div className="epmo_charts_row chart_row_new">
                  <div className="seperate_section">
                    <Card className="proj_list mb-2">
                      <DashboardCardHeader
                        title={props.t("Startup Stages")}
                        borderBottom="false"
                        fontSize="14px"
                      />
                      <ApexPieChartProjectStages
                        data={projectDashboardData?.projectStageGraph}
                        role={selectedRole}
                      />
                    </Card>
                    <Card className="proj_list mb-2">
                      <DashboardCardHeader
                        title={props.t("Deliverable Status")}
                        borderBottom="false"
                        fontSize="14px"
                      />
                      <ApexPieChartProjectStages
                        data={projectDashboardData?.deliverableStatus}
                        module={Modules.DELIVERABLE}
                        role={selectedRole}
                      />
                      {/* <ApexPieChartProjectStatus data={[projectDashboardData?.projectOnLateCount, projectDashboardData?.projectOnTrackCount]} role={selectedRole} /> */}
                    </Card>
                    {/* <Card className="proj_list mb-2">
                  <DashboardCardHeader
                    title={"Finance"}
                    borderBottom="false"
                    fontSize="14px" />
                  <ApexColumnGroupFinance data={financeChartData} />
                </Card> */}
                    <Card className="proj_list mb-2">
                      <DashboardCardHeader
                        title={props.t("Sectors Segmentation")}
                        borderBottom="false"
                        fontSize="14px"
                      />
                      <ApexPieChartProjectStages
                        data={projectDashboardData?.projectTechnologySector}
                        role={selectedRole}
                        module="sector"
                      />
                      {/* <ApexColumnChangeRequest data={projectDashboardData?.changeRequestGraph} /> */}
                    </Card>
                  </div>
                  {/* <div className="dashboardCardStats epmo_dash_cards mb-2">
                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2"
                          style={{
                            backgroundColor: "#D6FBF9",
                            color: "#316BE8",
                          }}
                        >
                          <AssignmentTurnedInOutlinedIcon />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            const filterFields = [
                              "status",
                              "projectUsers",
                              "ips",
                            ];
                            const filterInputs = [
                              ProjectStatuses.ONGOING,
                              selectedRole,
                              "",
                            ];
                            navigate("/all-projects", {
                              state: {
                                filterData: JSON.stringify({
                                  filterFields: filterFields,
                                  filterInputs: filterInputs,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {projectDashboardData?.totalIpsCount}
                          </div>
                          <div className="statText">{props.t("Total IPs")}</div>
                        </div>
                      </div>
                    </div>
                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2"
                          style={{
                            backgroundColor: "#BFF2EF",
                            color: "#18B8AF",
                          }}
                        >
                          <PeopleOutlinedIcon />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            navigate("/stakeholder-list", {
                              state: {
                                filterData: JSON.stringify({
                                  role: selectedRole,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {projectDashboardData?.totalStakeHolder}
                          </div>
                          <div className="statText">{props.t("Offtakers")}</div>
                        </div>
                      </div>
                    </div>

                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2"
                          style={{
                            backgroundColor: "#BFF2EF",
                            color: "#18B8AF",
                          }}
                        >
                          <img
                            style={{ objectFit: "cover" }}
                            src={MaleAVatar}
                            alt="male_avatar"
                            className="rounded-circle header-profile-user"
                          />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            const filterFields = [
                              "gender",
                              "role"
                            ];
                            const filterInputs = [
                              'Male',
                              Role.PROJECT_MANAGER,
                            ];
                            navigate("/user-list", {
                              state: {
                                filterData: JSON.stringify({
                                  filterFields: filterFields,
                                  filterInputs: filterInputs,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {malePM}
                          </div>
                          <div className="statText">{props.t("Male Founders")}</div>
                        </div>
                      </div>
                    </div>
                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2"
                          style={{
                            backgroundColor: "#BFF2EF",
                            color: "#18B8AF",
                          }}
                        >
                          <img
                            style={{ objectFit: "cover" }}
                            src={FemaleAVatar}
                            alt="female_avatar"
                            className="rounded-circle header-profile-user"
                          />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            const filterFields = [
                              "gender",
                              "role"
                            ];
                            const filterInputs = [
                              'Female',
                              Role.PROJECT_MANAGER,
                            ];
                            navigate("/user-list", {
                              state: {
                                filterData: JSON.stringify({
                                  filterFields: filterFields,
                                  filterInputs: filterInputs,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {femalePM}
                          </div>
                          <div className="statText">{props.t("Female Founders")}</div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2"
                          style={{
                            backgroundColor: "#FFEDBE",
                            color: "#D39C0D",
                          }}
                        >
                          <WarningAmberOutlinedIcon />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            navigate("/challenge-list", {
                              state: {
                                filterData: JSON.stringify({
                                  role: selectedRole,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {projectDashboardData?.challengesList?.length}
                          </div>
                          <div className="statText">
                            {props.t("Challenges")}
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="card proj_list">
                      <div className='statCardWrapper d-flex'>
                        <div className='iconBox2' style={{ backgroundColor: '#D8F1FF', color: '#2299E8' }}>
                          <ArticleOutlinedIcon />
                        </div>
                        <div className='statWrapper'>
                          <div className='statCount'>{projectDashboardData?.totalDocument}</div>
                          <div className='statText'>Documents</div>
                        </div>
                      </div>
                    </div> */}
                </div>
                <div className="dashboardCardStats epmo_dash_cards mb-2">
                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2 me-2"
                          style={{
                            backgroundColor: "#D6FBF9",
                            color: "#316BE8",
                          }}
                        >
                          <AssignmentTurnedInOutlinedIcon />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            const filterFields = [
                              "status",
                              "projectUsers",
                              "ips",
                            ];
                            const filterInputs = [
                              ProjectStatuses.ONGOING,
                              selectedRole,
                              "",
                            ];
                            navigate("/all-projects", {
                              state: {
                                filterData: JSON.stringify({
                                  filterFields: filterFields,
                                  filterInputs: filterInputs,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {projectDashboardData?.totalIpsCount}
                          </div>
                          <div className="statText">{props.t("Total IPs")}</div>
                        </div>
                      </div>
                    </div>
                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2 me-2"
                          style={{
                            backgroundColor: "#BFF2EF",
                            color: "#18B8AF",
                          }}
                        >
                          <PeopleOutlinedIcon />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            navigate("/stakeholder-list", {
                              state: {
                                filterData: JSON.stringify({
                                  role: selectedRole,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {projectDashboardData?.totalStakeHolder}
                          </div>
                          <div className="statText">{props.t("Offtakers")}</div>
                        </div>
                      </div>
                    </div>

                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2 me-2"
                          style={{
                            backgroundColor: "#BFF2EF",
                            color: "#18B8AF",
                          }}
                        >
                          <img
                            style={{ objectFit: "cover" }}
                            src={MaleAVatar}
                            alt="male_avatar"
                            className="rounded-circle header-profile-user"
                          />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            const filterFields = [
                              "gender",
                              "role"
                            ];
                            const filterInputs = [
                              'Male',
                              Role.PROJECT_MANAGER,
                            ];
                            navigate("/user-list", {
                              state: {
                                filterData: JSON.stringify({
                                  filterFields: filterFields,
                                  filterInputs: filterInputs,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {malePM}
                          </div>
                          <div className="statText">{props.t("Male Founders")}</div>
                        </div>
                      </div>
                    </div>
                    <div className="card proj_list">
                      <div className="statCardWrapper d-flex">
                        <div
                          className="iconBox2 me-2"
                          style={{
                            backgroundColor: "#BFF2EF",
                            color: "#18B8AF",
                          }}
                        >
                          <img
                            style={{ objectFit: "cover" }}
                            src={FemaleAVatar}
                            alt="female_avatar"
                            className="rounded-circle header-profile-user"
                          />
                        </div>
                        <div
                          className="statWrapper cursor-pointer"
                          onClick={() => {
                            const filterFields = [
                              "gender",
                              "role"
                            ];
                            const filterInputs = [
                              'Female',
                              Role.PROJECT_MANAGER,
                            ];
                            navigate("/user-list", {
                              state: {
                                filterData: JSON.stringify({
                                  filterFields: filterFields,
                                  filterInputs: filterInputs,
                                }),
                              },
                            });
                          }}
                        >
                          <div className="statCount">
                            {femalePM}
                          </div>
                          <div className="statText">{props.t("Female Founders")}</div>
                        </div>
                      </div>
                    </div>
                  </div> 
                <div className="epmo_tables d-flex flex-row">
                  <div className="proj_list mb-2 w-100">
                    <h5>{props.t("Startup List")}</h5>
                    <ul className="list-inline mb-0">
                      {projectDashboardData?.totalRunningProject?.length > 0 ? (
                        projectDashboardData?.totalRunningProject?.map(
                          (item, index) => (
                            <li
                              className="projs cursor-pointer"
                              key={index}
                              onClick={() =>
                                navigate(`/project/${item?.id}/details`)
                              }
                            >
                              <span
                                className="colored_block"
                                style={{
                                  background: SectorColor(item?.sector),
                                }}
                              ></span>
                              {item.name}
                            </li>
                          )
                        )
                      ) : (
                        <NoDataFound text="No data found" icon={Ticket} />
                      )}
                    </ul>
                  </div>
                  {/* <div className="proj_list grey_bg mb-3 p-0">
                    <h5>{props.t('Challenges Details')}</h5>
                    <ul className="recentTaskListing p-0 list-inline">
                      <li>
                        <div className="d-grid threeColumns justify-content-between align-items-center">
                          <div className="challenge_header taskBasicDetail">{props.t('Challenges')}</div>
                          <div className="challenge_header teamPersonName">{props.t('Startup')}</div>
                          <div className="challenge_header statusChip">{props.t('Support Needed')}</div>
                        </div>
                      </li>
                      {projectDashboardData?.challengesList?.length > 0 ? projectDashboardData?.challengesList.map((item, index) => (
                        <li key={index}>
                          <div className="d-grid threeColumns justify-content-between align-items-center">
                            <div className="taskBasicDetail">{item?.description}</div>
                            <div className="teamPersonName">{item?.project?.name}</div>
                            <div className="statusChip">{item?.supportNeeded}</div>
                          </div>
                        </li>
                      )) : (
                        <NoDataFound text="No data found" icon={Ticket} />
                      )}
                    </ul>
                  </div> */}
                  {/* <Card className="proj_list mb-3">
                    <DashboardCardHeader
                      title={props.t("Startup Type")}
                      borderBottom="false"
                      fontSize="14px"
                    />
                    <ApexPieChartProjectStages
                      data={startupType ? startupType : []}
                      role={selectedRole}
                      module="projectType"
                    />
                  </Card> */}
                  {/* {selectedRole === Role.EPMO_OFFICER && (
                    <Card className="proj_list mb-2 w-100">
                      <DashboardCardHeader
                        title={props.t("Startup Assessment")}
                        borderBottom="false"
                        fontSize="14px"
                      />
                      <ApexPieChartProjectStages
                        data={projectDashboardData?.ratingGraph}
                        role={selectedRole}
                        module="rating"
                      />
                    </Card>
                  )} */}
                  <Card className="proj_list mb-2 w-100">
                    <DashboardCardHeader
                      title={props.t("Investment Stages")}
                      borderBottom="false"
                      fontSize="14px"
                    />
                    <ApexPieChartProjectStages
                      data={projectDashboardData?.isProjectStage}
                      role={selectedRole}
                      module="fundStage"
                    />
                  </Card>
                </div>
                {["NTDP", "JST",'RCT'].includes(loggedInUser?.company?.name) && (
                  <>
                    <div className="epmo_charts_row">
                      <Card className="proj_list mb-3">
                        <DashboardCardHeader
                          title={props.t("Startup Technology Type")}
                          borderBottom="false"
                          fontSize="14px"
                        />
                        <ApexBarTechnology
                          data={projectDashboardData?.projectTechnologyType}
                          role={selectedRole}
                        />
                      </Card>
                      {/* <Card className="proj_list mb-3">
                      <DashboardCardHeader
                        title={" Projects Technology Sector"}
                        borderBottom="false"
                        fontSize="14px" />
                      <ApexBarTechnologySector data={projectDashboardData?.projectTechnologySector} role={selectedRole} />
                    </Card> */}
                      <div className="dashboardCardStats epmo_dash_cards mb-2">
                        <div className="card proj_list">
                          <div className="statCardWrapper d-flex">
                            <div
                              className="iconBox2"
                              style={{
                                backgroundColor: "#FFFAD0",
                                color: "#FB9D07",
                              }}
                            >
                              <AccountBalanceWalletOutlinedIcon />
                            </div>
                            <div className="statWrapper">
                              <div className="statCount">
                                {projectDashboardData?.totalRevenue ?? 0}
                              </div>
                              <div className="statText">
                                {props.t("Total Revenue")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card proj_list">
                          <div className="statCardWrapper d-flex">
                            <div
                              className="iconBox2"
                              style={{
                                backgroundColor: "#FFFAD0",
                                color: "#FB9D07",
                              }}
                            >
                              <AccountBalanceWalletOutlinedIcon />
                            </div>
                            <div className="statWrapper">
                              <div className="statCount">
                                {projectDashboardData?.totalValuation ?? 0}
                              </div>
                              <div className="statText">
                                {props.t("Total Valuation")}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="card proj_list">
                          <div className="statCardWrapper d-flex">
                            <div
                              className="iconBox2"
                              style={{
                                backgroundColor: "#FFFAD0",
                                color: "#FB9D07",
                              }}
                            >
                              <AssignmentTurnedInOutlinedIcon />
                            </div>
                            <div className="statWrapper">
                              <div className="statCount">
                                {projectDashboardData?.totalJobs ?? 0}
                              </div>
                              <div className="statText">
                                {props.t("Number of Jobs")}
                              </div>
                            </div>
                          </div>
                        </div> */}
                        {/* <div className="card proj_list">
                      <div className='statCardWrapper d-flex'>
                        <div className='iconBox2' style={{ backgroundColor: '#D8F1FF', color: '#2299E8' }}>
                          <ArticleOutlinedIcon />
                        </div>
                        <div className='statWrapper'>
                          <div className='statCount'>{projectDashboardData?.totalDocument}</div>
                          <div className='statText'>Documents</div>
                        </div>
                      </div>
                    </div> */}
                      </div>
                    </div>
                    {/* <div className='dashboard_upper_cards'>
                      <Minicard reports={Stats} />
                      </div> */}
                    <div
                      className="epmo_charts_row"
                      // style={{ gridTemplateColumns: "2fr 1fr 1fr" }}
                      style={{ gridTemplateColumns: "auto auto auto" }}
                    >
                      <Card className="proj_list mb-3">
                        <DashboardCardHeader
                          title={props.t("TRL Status")}
                          borderBottom="false"
                          fontSize="14px"
                        />
                        <ApexPieChartProjectStages
                          data={projectDashboardData?.isTRLWiseProject}
                          role={selectedRole}
                          module="isTRL"
                        />
                      </Card>
                      {/* <Card className="proj_list mb-3">
                        <DashboardCardHeader
                          title={props.t("Investment Stages")}
                          borderBottom="false"
                          fontSize="14px"
                        />
                        <ApexPieChartProjectStages
                          data={projectDashboardData?.isProjectStage}
                          role={selectedRole}
                          module="fundStage"
                        />
                      </Card> */}
                      <Card className="proj_list mb-3">
                        <DashboardCardHeader
                          title={props.t("Offtakers State of Communication")}
                          borderBottom="false"
                          fontSize="14px"
                        />
                        <ApexPieChartProjectStages
                          data={
                            projectDashboardData?.stakeHolderCommunationStateGraph
                          }
                          role={selectedRole}
                          module={Modules.STAKEHOLDER}
                        />
                      </Card>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {isDrawerOpen && (
        <AddProjectDrawer
          isOpen={isDrawerOpen}
          handleClose={handleCloseDrawer}
        />
      )}
    </div>
  );
};

export default withTranslation()(DashboardNew);
